import React from "react";

import { ConfirmModal } from "./ui/confirm-modal";

interface UnsavedChangesModalProps {
    open: boolean;
    /** Called with `false` for any user-initiated dismissal (X,
     *  Escape, backdrop click). Treated as "keep editing" — the
     *  pending navigation is dropped without firing. */
    onOpenChange: (open: boolean) => void;
    /** Confirm action: discard the unsaved changes and proceed with
     *  the pending navigation. */
    onDiscard: () => void;
}

/**
 * Confirmation modal shown when the user attempts to navigate while
 * the unsaved-changes guard has flagged a dirty form. Thin wrapper
 * over the shared `ConfirmModal` primitive so the copy + destructive
 * tone live in one place.
 *
 * Per the ConfirmModal convention there is no explicit Cancel button
 * — dismissal (X / Escape / backdrop) reads as "keep editing".
 */
export function UnsavedChangesModal({
    open,
    onOpenChange,
    onDiscard
}: UnsavedChangesModalProps): React.ReactElement {
    return (
        <ConfirmModal
            open={open}
            onOpenChange={onOpenChange}
            title="Discard unsaved changes?"
            description="You have changes that haven't been applied yet. Leaving now will lose them."
            confirmLabel="Discard Changes"
            destructive
            onConfirm={onDiscard}
        />
    );
}
